import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [4,2];

export const dictionary = {
		"/(public)": [10,[3]],
		"/app": [13,[4]],
		"/app/delivery/[identifier]": [~14,[4,5]],
		"/app/order-confirmation/fiken": [~15,[4]],
		"/app/sales": [~16,[4]],
		"/app/sales/fiken": [~17,[4]],
		"/app/settings": [~18,[4,6]],
		"/app/settings/fiken": [~19,[4,6]],
		"/app/settings/profrakt": [~20,[4,6]],
		"/app/settings/profrakt/[env]/apikey": [~21,[4,6]],
		"/app/settings/profrakt/[env]/select-company": [~22,[4,6]],
		"/app/settings/profrakt/[env]/user": [~23,[4,6]],
		"/callback/fiken": [~24],
		"/(auth)/login": [~7,[2]],
		"/(auth)/logout": [~8,[2]],
		"/(public)/privacy": [11,[3]],
		"/(auth)/register": [~9,[2]],
		"/sentry-example": [25],
		"/(public)/terms": [12,[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: universal_hooks.reroute || (() => {})
};

export { default as root } from '../root.svelte';